<template>
  <div class="messages">
    <ul>
      <li><strong>QUEOTA</strong>: Usem o chat com bom senso. Respeitem a todos.</li>
      <li class="warn">O servidor será iniciado quando todos os jogadores estiverem prontos</li>
      <li class="warn-b">Iremos informar o IP aqui no chat</li>
      <li v-for="msg in chatMessages">
        <div :class="`chat-message ${msg.user_team}`">
          <span class="time">[{{msg.timestamp}}]</span> <strong>{{msg.user}}</strong>: {{msg.message}}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  props: ['chatMessages'],
  watch: {
    chatMessages() {
      let chatBox = this.$el.querySelector('.messages ul');
      chatBox.scrollTop = chatBox.scrollHeight + 150;
    }
  },
  data: function () {
    return {
    }
  },
  methods: {
    initialize () {
    }
  },
  created () {
    this.initialize()
  }
}
</script>

<style scoped lang="sass">
  $green: #62c462
  $blue: #008EB4

  .messages
    background: rgba(0, 0, 0, .55)
    border-bottom-left-radius: 4px
    border-bottom-right-radius: 4px
    ul
      margin: 0
      padding: 20px 20px 25px
      height: 300px
      overflow: scroll  
    ul::-webkit-scrollbar
      width: 0px
      background: transparent
    ul::-webkit-scrollbar-thumb
      background: green
    ul li
      font-size: 14px
      margin-bottom: 0
      list-style: none
      color: white
      &.warn
        color: yellow
        font-weight: bold
      .chat-message
        &.teamA strong
          color: $blue
        &.teamB strong
          color: $green
        
        .time
          color: #333
          font-size: 12px
          display: inline-block
          margin-right: 4px

  
</style>
